<!--
 * @Description: 看报告
 * @Author:  单珊珊
 * @Date: 2022-02-17 16:51:59
 * @LastEditTime: 2022-05-19 09:48:19
 * @LastEditors:  
-->
<template>
<div class="first-container">
  <!-- <div class="prompt-content">
    <p>动脉网PC3.0抢先体验：7*24小时情报追踪、结构化认知医疗行业大事、医疗产业资源对接等，<a :href="$store.state.index2_path + '/new'">立即体验</a></p>
  </div> -->
  <!-- <div class="prompt-content">
      <p>NEW！动脉网全新域名</p>
      <a>https://www.vbdata.cn</a>
      <p>正式启用，原网址仍支持访问</p>
    </div> -->
  <div class="company-filter">
    <DataNavigation ref="data-nav"></DataNavigation>
    <div class="main-container">

      <!-- <div class="main-banner">
        <div class="left">
          <a @click="goToAdv(banner1)" target="_blank" onclick="_czc.push(['_trackEvent', '看报告(新)', '顶部广告(左)', '点击量'])">
            <img :src="banner1.imgPath | logo_show" class="banner-img">
          </a>
        </div>
        <div class="right">
          <div class="top">
            <a @click="goToAdv(banner2)" target="_blank" onclick="_czc.push(['_trackEvent', '看报告(新)', '顶部广告(右上)', '点击量'])">
              <img :src="banner2.imgPath | logo_show" class="banner-img">
            </a>
          </div>
          <div class="bottom">
            <a @click="goToAdv(banner3)" target="_blank" onclick="_czc.push(['_trackEvent', '看报告(新)', '顶部广告(右)', '点击量'])">
              <img :src="banner3.imgPath | logo_show" class="banner-img">
            </a>
          </div>
        </div>
      </div> -->
      <div class="main-content">
        <div class="left-wrap">
          <div class="search-area">
            <div class="area flex-content">
              <div class="type-title">相关领域：</div>
              <div class="type">
                <span v-for="item, index in entity_ntag_filter" :key="index" class="search-item" :class="{'active': app_layer_tag == item.id}" @click="changeArea(item.id)">{{item.name}}</span>
              </div>
            </div>
            <div class="report-type flex-content">
              <div class="type-title">报告种类：</div>
              <div class="type">
                <span v-for="item, index in type_list" :key="index" class="search-item" :class="{'active': type == item.value}" @click="changeType(item.value)">{{item.label}}</span>
              </div>
            </div>
            <div class="time flex-content">
              <div class="type-title">报告时间：</div>
              <div class="type">
                <span v-for="item, index in year_list" :key="index" class="search-item" :class="{'active': year == item.value}" @click="changeYear(item.value)">{{item.label}}</span>
              </div>
            </div>
            <div class="keywords">
              <div class="type">
                <span class="type-title">报告搜索：</span>
                <!-- <input v-model="keyword" placeholder="搜索“报告名称”、“报告简介”、“视频名称”、“数据图表”" @blur="changeKey" /> -->
                <Input v-model="keyword" search placeholder="搜索“报告名称”、“报告简介”、“关键词”、“数据图表”" @on-search="changeKey" clearable @on-change="changeKey" />
              </div>
            </div>
          </div>
          <div class="report-list"  v-if="report_list.length > 0">
            <div class="report-item" v-for="repo, index1 in report_list" :key="index1">
              <div class="top">
                <div class="report-image">
                  <img :src="repo.filePath | logo_show" alt="" @click="goToDetail(repo)">
                  <span class="report-type">{{repo.type == 2 ? '视频' : repo.categoryName}}</span>
                  <span class="video-duration" v-if="repo.type == 2 && repo.duration > 0">{{repo.duration | time_deal}}</span>
                  <span class="video-run" v-if="repo.type == 2" @click="goToDetail(repo, 1)"><i class="iconfont">&#xe60f;</i></span>
                  <div class="shoucang" v-if="!repo.isCollect" @click="addCollect(repo.type == 2 ? '4' : '1', repo.id, addCollectCb, index1)">
                    <i class="iconfont">&#xe667;</i>
                  </div>
                  <div class="shoucang on" v-else @click="cancelCollect(repo.type == 2 ? '4' : '1', repo.id, delCollectCb, index1)">
                    <i class="iconfont">&#xe667;</i>
                  </div>
                </div>
                <div class="report-info">
                  <div class="title l2-ellipsis" @click="goToDetail(repo, 2)" v-html="repo.title_keyword"></div>
                  <a :href="repo.type == 2 ? $store.state.index2_path + '/' + repo.id : $store.state.index_path + '/reportDetail/' + repo.uid"></a>
                  <div class="detail l2-ellipsis">{{repo.summary}}</div>
                  <div class="track" v-if="repo.entityTags">
                    <span class="normal">相关赛道</span>
                    <span class="topic" v-show="tagIndex < 3" v-for="tag, tagIndex in repo.entityTags" :key="tagIndex" @click="goToTrackDetail(tag.id)">{{tag.name}}</span>
                  </div>
                  <div class="state">
                    <div class="free">{{repo.price == 0 ? '免费' : '￥'+repo.price}}</div>
                    <div class="update">
                      <div class="time"><i class="iconfont">&#xe632;</i>{{repo.publishTime | time_standard}}</div>
                      
                    </div>
                  </div>
                </div>
              </div>
              <div class="report-chart" v-if="repo.reportChart.length > 0">
                <div class="item-wrap">
                  <div class="chart-item" v-for="chart,index2 in repo.reportChart" :key="index2" v-show="index2 < repo.max" @click.stop="handReport(chart, 1)">
                    <div class="chart">
                      <img v-if="chart.reportType == 0" :src="chart.filePath | logo_show('/report_type_img')" alt="" srcset="">
                      <img v-else :src="chart.filePath | logo_show('/report_image')" alt="" srcset="">
                      <span class="shoucang" v-if="chart.isCollect == 0" @click.stop="addCollect('9', chart.id, addCollectCb2, {index1: index1, index2: index2})"><i class="iconfont">&#xe667;</i></span>
                      <span class="shoucang on" v-else @click.stop="cancelCollect('9', chart.id, delCollectCb2, {index1: index1, index2: index2})"><i class="iconfont">&#xe667;</i></span>
                    </div>
                    <div class="chart-title l2-ellipsis">{{chart.fileName}}</div>
                  </div>
                </div>
                <div class="desc">
                  <div class="number">该报告包含{{repo.total}}张图表</div>
                  <button class="folder" v-if="repo.reportChart.length > 4 && repo.max == 4" @click="showMoreChart(repo)">展开</button>
                  <button class="more-chart" v-if="repo.reportChart.length > 4 && repo.max == 8" @click="goToDetail(repo, 3)">查看更多</button>
                </div>
              </div>
              <!--图表聚合-->
              <div class="report-chart chart-set" v-show="getShow(index1)">
                <div class="item-wrap">
                  <div class="chart-item" v-for="chart_z,index3 in chart_set.records" :key="index3" v-show="index3 < 8" @click="handReport(chart_z, 2)">
                    <div class="chart">
                      <img v-if="chart_z.reportType == 0" :src="chart_z.filePath | logo_show('/report_type_img')" alt="" srcset="">
                      <img v-else :src="chart_z.filePath | logo_show('/report_image')" alt="" srcset="">
                      <!-- <span class="shoucang"><i class="iconfont">&#xe667;</i></span> -->
                      <span class="shoucang" v-if="!chart_z.isCollect" @click.stop="addCollect('9', chart_z.id, addCollectCb3, index3)"><i class="iconfont">&#xe667;</i></span>
                      <span class="shoucang on" v-else @click.stop="cancelCollect('9', chart_z.id, delCollectCb3, index3)"><i class="iconfont">&#xe667;</i></span>
                    </div>
                    <div class="chart-title l2-ellipsis" v-html="chart_z.file_name_keyword"></div>
                  </div>
                </div>
                <div class="more-char-set" @click="goToChartSet"><button>查看更多{{chart_set.total}}张数据图表</button></div>
              </div>
            </div>
          </div>
          <div class="defalut" v-if="!loading && report_list.length < 1">
            <img :src="$store.state.static_img_url+'pic/quesheng-2.png'" alt="" srcset="">
            <p>暂无符合筛选条件的内容</p>
          </div>
          <div class="login-tip" v-if="login_bl && !user_key">
            如需继续查看，请先<span @click="login">登录账号</span>
          </div>
          <Spin v-if="loading">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
          </Spin>
        </div>
        <RightModel class="right-wrap" ref="right-model">
          <rcReport :limit="3" :isMore="false"></rcReport>
          <reportChart style="margin-top: 30px;"></reportChart>
        </RightModel>
      </div>
      <ReportModal :isReportModal="is_reportModal" :detail="detail" :preview="2" :relation="relation" @closeModal="closeModal"></ReportModal>
    </div>
  </div>
</div>
</template>

<script>
import rcReport from '@/components/vcbeat/RCreport'
import reportChart from '@/components/vcbeat/ReportChart'
import DataNavigation from '@/components/DataNavigation'
import ReportModal from '@/components/vcbeat/ReportModal'
import { getMeta, getReportList, getReportChartList, getBanner, addPuv } from '@/service.js'
import filter from 'js/filter'
import moment from 'moment'
import { collect_mixin } from "js/collect_mixin";
import RightModel from '@/components/RightModel'
function check() {
    function doCheck(a) {
        (function() {}["constructor"]("debugger")()); 
        doCheck(++a);
    }
    try {
        doCheck(0)
    } catch(err) {}
}
export default {
  mixins: [collect_mixin],
  inject: ["login"],
  components: { rcReport, reportChart, DataNavigation, ReportModal, RightModel },
  data() {
    return {
      debugger_interval: '',
      type: 0,
      app_layer_tag: '0', //相关领域
      year: 0,
      page: 1,
      keyword: '',
      length: 0,
      max: 4,
      loading: true,
      is_reportModal: false,
      detail: {},
      relation: [],
      type_list: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 2,
          label: '原创报告'
        },
        {
          value: 1,
          label: '免费报告'
        },
        {
          value: 3,
          label: '数据图表报告'
        },
      ],
      entity_ntag: [
        {
          id: '0',
          name: '全部'
        }
      ],
      year_list: [
        {
          value: 0,
          label: '全部'
        }
      ],
      report_list: [],
      chart_set: [], //图表聚合
      banner1: {},
      banner2: {},
      banner3: {},
      login_bl: false
    }
  },
  computed: {
    img_req_url() {
      return this.$store.state.img_req_url
    },
    getShow() {
      return function (index) {
        if (this.report_list.length > 5 && index == 4 && this.app_layer_tag == '0' && this.chart_set.total > 0) {
          return true
        } else if (
          this.report_list.length <= 5 &&
          index == this.report_list.length - 1 &&
          this.app_layer_tag == '0' &&
          this.chart_set.total > 0
          ) {
          return true
        } else {
          return false
        }
      }
    },
    entity_ntag_filter() {
      let arr = this.entity_ntag.filter(item => item.pid == null)
      let index = arr.findIndex(a => a.id == 21)
      if(index > -1) {
        let e = arr[index]
        arr.splice(index, 1)
        arr.splice(1, 0, e)
      }
      return arr
    },
    user_key() {
      return this.$store.state.user_key
    }
  },
  created() {
    let last_year = moment().locale('zh-cn').format('YYYY')
    for (let i = 0; i < 8; i++) {
      this.year_list.push({
        value: last_year - i,
        label: last_year - i
      })
    }
    // this.getBanner()
  },
  beforeMount() {
    this.getMeta()
    if (this.app_layer_tag == '0') {
      this.getReportChartList()
    }
  },
  mounted() {
    if (process.env.NODE_ENV != 'development') {
      check()
      this.debugger_interval = setInterval(() => {
        check()
      }, 2000)
    }
    this.$nextTick(() => {
      window.onscroll = this.debounce(() => {
        this.$refs['data-nav'].scrollChange()
        this.$refs['right-model'].scrollChange()
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        if (scrollTop > (scrollHeight - windowHeight - 100) && !this.loading && scrollTop > 0 && !this.login_bl) {
          this.getMoreList()
        }
      }, 10)
    })
  },
  beforeDestroy() {
    clearInterval(this.debugger_interval)
    this.debugger_interval = ''
  },
  watch: {
    app_layer_tag(newVal, oldVal) {
      if (newVal == '0') {
        this.getReportChartList()
      }
    }
  },
  methods: {
    //广告位跳转-统计
    goToAdv(banner) {
      window.open(banner.link, '_blank')
      this.addPuv(banner.uid)
    },
    addCollectCb(index) {
      // console.log(index)
      this.report_list[index].isCollect = 1
      _czc.push(['_trackEvent', '看报告(新)', '报告信息流(收藏/取消收藏)', '点击量'])
    },
    addCollectCb2(params) {
      this.report_list[params.index1]['reportChart'][params.index2].isCollect = 1
      this.report_list = [...this.report_list]

      // console.log(this.report_list, params)
      this.$forceUpdate();
    },
    addCollectCb3(index) {
      this.chart_set.records[index].isCollect = 1
      this.chart_set = [...this.chart_set]
      this.$forceUpdate();
    },
    delCollectCb(index) {
      this.report_list[index].isCollect = 0
      _czc.push(['_trackEvent', '看报告(新)', '报告信息流(收藏/取消收藏)', '点击量'])
    },
    delCollectCb2(params) {
      this.report_list[params.index1]['reportChart'][params.index2].isCollect = 0
      this.report_list = [...this.report_list]
      this.$forceUpdate();
    },
    delCollectCb3(index) {
      this.chart_set.records[index].isCollect = 0
      this.chart_set = [...this.chart_set]
      this.$forceUpdate();
    },
    async addPuv(uid) {
      let res = await addPuv({
        url: "https://www.vbdata.cn/advClick?uid="+uid,
      })
    },
    //获取相关领域
    async getMeta() {
      let res = await getMeta({ name: ['entity_ntag'] }, (error) => {
        this.$Message.error('元数据请求错误！')
      })
      if (res.status == 'success') {
        res.meta.entity_ntag.map(item => {
          this.entity_ntag.push(item)
        })
        this.getReportList()
      }
    },
    //获取报告列表
    async getReportList() {
      this.length = 0
      this.loading = true
      let params = {
        page: this.page,
        keyword: this.keyword,
        app_layer_tag: parseInt(this.app_layer_tag),
        type: this.type,
        year: this.year,
        user_key: this.$store.state.user_key || ''
      }
      let res = await getReportList(params, (error) => {
        this.$Message.error('请求错误！')
      })
      this.loading = false
      if (res.code == 0) {
        let current_list = res.data
        this.length = res.data.length
        // this.report_list = res.data
        current_list.map(item => {
          // let values = item.title.split(this.keyword);
          let title_keyword =  this.keyword ? filter.keyWordHighLight(item.title, this.keyword) : item.title
          this.$set(item, 'title_keyword', title_keyword)
          if (item.appLayerTagId) {
            let ids = item.appLayerTagId.split(',')
            let entityTags = []
            ids.map(id => {
              entityTags.push({
                id: id,
                name: filter.dealNeed(id, this.entity_ntag)
              })
            })
            this.$set(item, 'entityTags', entityTags)
          }
          this.$set(item, 'max', 4)
        })
        this.report_list = [...this.report_list, ...current_list]
        // console.log('report_list', this.report_list);
        this.$nextTick(() => {
          this.$refs['data-nav'].scrollChange()
          this.$refs['right-model'].scrollChange()
        })
      } else {
        this.$Message.error(res.msg)
      }
    },
    //获取报告图表
    async getReportChartList() {
      let params = {
        name: this.keyword,
        app_layer_tag: [],
        page: 1,
        size: 8,
        user_key: this.$store.state.user_key
      }
      let res = await getReportChartList(params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.code == 0) {
        // this.chart_set = res.data
        this.$set(this.$data, 'chart_set', res.data)
        this.chart_set.records.map(item => {
          let values = item.fileName.split(this.keyword);
          let file_name_keyword =  this.keyword ? filter.keyWordHighLight(item.fileName, this.keyword) : item.fileName
          this.$set(item, 'file_name_keyword', file_name_keyword)
        })
      } else {
        this.$Message.error(res.msg)
      }
    },
    changeType(val) {
      this.type = val
      this.page = 1
      this.report_list = []
      this.getReportList()
      _czc.push(['_trackEvent', '看报告(新)', '报告筛选(种类)', '点击量'])
    },
    //图表弹窗
    async handReport(item, type) {
      if (!this.user_key) {
        this.login()
        return
      }
      this.detail = item
      // console.log(item);
      let res = await getReportChartList({
        file_id: this.detail.id,
        app_layer_tag: this.detail.reportTag,
        name: '',
        page: 1,
        size: 3
      }, (error) => {
        this.$message.error('请求错误！')
      })
      if (res.code == 0) {
        this.$set(this.$data, 'relation', res.data.records)
        this.is_reportModal = true
      } else {
        this.$message.error(res.msg)
      }
      switch(type) {
        case 1:
          _czc.push(['_trackEvent', '看报告(新)', '报告信息流(图表报告_报告)', '点击量'])
          break;
        case 2:
          _czc.push(['_trackEvent', '看报告(新)', '报告信息流(聚合推荐报告_报告)', '点击量'])
          break;
      }

    },
    // 广告位
    async getBanner() {
      this.banner_loading = true
      let res = await getBanner({
        position_id: ['56', '57', '58']
      }, (error) => {
        this.$message.error('请求错误！')
      })
      if (res.code == 0) {
        res.data.forEach(item => {
          if(item.posId == '56'){
            this.banner1 = item
          } else if(item.posId == '57'){
            this.banner2 = item
          } else if(item.posId == '58'){
            this.banner3 = item
          }
        });
        this.banner_loading = false
      } else {
        this.$message.error(res.msg)
      }
    },
    changeArea(val) {
      this.page = 1
      this.app_layer_tag = parseInt(val)
      this.report_list = []
      this.getReportList()
      _czc.push(['_trackEvent', '看报告(新)', '报告筛选(领域)', '点击量'])
    },
    changeYear(val) {
      this.page = 1
      this.year = val
      this.report_list = []
      this.getReportList()
      _czc.push(['_trackEvent', '看报告(新)', '报告筛选(时间)', '点击量'])
    },
    changeKey() {
      this.page = 1
      this.report_list = []
      this.getReportList()
      this.getReportChartList()
      _czc.push(['_trackEvent', '看报告(新)', '报告搜索', '点击量'])
    },
    //展开图表
    showMoreChart(repo) {
      this.$set(repo, 'max', 8)
    },
    // 滚动条防抖
    debounce(fn, wait) {
      let timeout = null
      return () => {
        if (timeout !== null) {
          clearTimeout(timeout)
        }
        timeout = setTimeout(fn, wait)
      }
    },
    //滚动分页
    getMoreList() {
      if (this.length == 20) {
        if(this.page > 2 && !this.user_key) {
          this.login()
          this.login_bl = true
        } else {
          ++this.page
          this.getReportList()
        }
      }
    },
    //关闭弹窗
    closeModal(val) {
      this.is_reportModal = false
    },
    //跳转至图表聚合
    goToChartSet() {
      const { href } = this.$router.resolve(this.keyword ? { name: 'chartSet', query: {keyword: this.keyword} } : { name: 'chartSet' })
      window.open(href, '_blank')
      _czc.push(['_trackEvent', '看报告(新)', '报告信息流(聚合推荐报告_更多)', '点击量'])
    },
    //跳转至报告或文章详情
    goToDetail(repo, type) {
      if (repo.type == 2) {
        const href = this.$store.state.index2_path + '/' + repo.id
        window.open(href, '_blank')
      } else {
        //跳转至报告详情
        const { href } = this.$router.resolve({ name: 'ReportDetail', params: { uid: repo.uid } })
        window.open(href, '_blank')
      }
      switch(type) {
        case 1:
          _czc.push(['_trackEvent', '看报告(新)', '报告信息流(视频报告_报告)', '点击量'])
          break;
        case 2:
          _czc.push(['_trackEvent', '看报告(新)', '报告信息流(标题)', '点击量'])
          break;
        case 3:
          _czc.push(['_trackEvent', '看报告(新)', '报告信息流(图表报告_更多)', '点击量'])
          break;
      }
    },
    //跳转至赛道详情
    goToTrackDetail(id) {
      const { href } = this.$router.resolve({ name: 'trackDetail', query: { tag: id } })
      window.open(href, '_blank')
      _czc.push(['_trackEvent', '看报告(新)', '报告信息流(标签)', '点击量'])
    },
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common_reporting.stylus'
@import '~styles/common_vcbeat.stylus'
.first-container
  background #fff
  display flex
  flex-direction column
.prompt-content
  width 100%
  height 28px
  background #FFECDC
  display flex
  justify-content center
  align-items center
  position fixed
  top 64px
  z-index 100
  p
    font-size 12px
    color #FA5A00
    a
      color #3652FF
      cursor pointer
.company-filter
  background #fff
  display flex
  justify-content center
  min-width 1200px
  position relative
.main-container
  width 1090px
  margin-left 20px
  padding 20px 0
  .main-banner
    display flex
    height 398px
    div
      overflow hidden
      img
        width 100%
        height 100%
        cursor pointer
        transition all .5s
        -webkit-transition all .5s
        &:hover
          transform scale(1.04)
          transition all 0.6s ease 0s
    .left
      flex 0 0 728px
      margin-right 20px
    .right
      display flex
      flex-direction column
      justify-content space-between
      flex 0 0 342px
      div
        height 187px
  .main-content
    margin-bottom 30px
    display flex
    justify-content space-between
    .left-wrap
      width 728px
      .search-area
        font-size 16px
        
        margin-bottom 30px
        .flex-content
          display flex
          align-items flex-start
          margin-bottom 30px
        .type-title
          font-weight bold
          color #333333
          display inline-block
          margin-right 20px
          white-space nowrap
          line-height 24px
        .type
          margin -10px -25px 0 0
        .search-item
          font-weight 500
          color #666666
          cursor pointer
          margin-right 25px
          display inline-block
          line-height 20px
          margin-top 10px
          line-height 24px
        .active
          color #FA5A00
        >>>.ivu-input-wrapper
          width 515px
        >>>.ivu-input
          &:focus
            box-shadow none
            border-color #FA5A00
          &:hover
            border-color #FA5A00
        >>>.ivu-input-search-icon
          &:hover
            color #FA5A00
      .defalut
        display flex
        flex-direction column
        align-items center
      .report-list
        position relative
        .report-item
          display flex
          flex-direction column
          &:not(:first-child)
            margin-top 25px
          .top
            display flex
            // justify-content space-between
            .report-image
              flex 0 0 242px
              height 152px
              position relative
              overflow hidden
              .shoucang
                display inline-flex
                justify-content center
                align-items center
                border-radius 3px
                margin-left 10px
                width 21px
                height 21px
                background #F3F3F3
                cursor pointer
                position absolute
                right 10px
                top 10px
                &.on
                  background #FA5A00
                  .iconfont
                    color #fff
                .iconfont
                  color #CCCCCC
                  font-size 14px
              img
                width 100%
                height 100%
                cursor pointer
                transition all .5s
                &:hover
                  transform scale(1.04)
                  transition all 0.6s ease 0s
              .report-type
                position absolute
                height 23px
                line-height 23px
                background #FA5A00
                opacity 0.8
                font-size 12px
                
                font-weight 500
                color #FFFFFF
                padding 0 6px
                top 10px
                left 10px
              .video-run
                position absolute
                height 60px
                width 60px
                display flex
                justify-content center
                align-items center
                background rgba(0, 0, 0, 0.6)
                border-radius 50%
                top 50%
                left 50%
                transform translate(-50%, -50%)
                cursor pointer
                .iconfont
                  font-size 27px
                  color #FFFFFF
                  transition all .5s
                  -webkit-transition all .5s
                  &:hover
                    transform scale(1.1)
                    transition all 0.6s ease 0s
              .video-duration
                width 64px
                height 22px
                background #000000
                opacity 0.6
                text-align center
                line-height 22px
                position absolute
                bottom 0
                right 0
                font-size 13px
                color #FFFFFF
            .report-info
              flex 0 0 470px
              
              font-weight 500
              display flex
              flex-direction column
              justify-content space-between
              margin-left 16px
              // .track
              //   span
              //     padding 8px
              .title
                font-size 18px
                color #333333
                line-height 24px 
                cursor pointer
                transition all .5s
                -webkit-transition all .5s
                >>> .high-light
                  font-style normal
                  color #FA5A00
                &:hover
                  color #FA5A00
              .detail
                font-size 13px
                color #666666
                line-height 18px
              .state
                display flex
                justify-content space-between
                align-items center
                .free
                  font-size 16px
                  color #FFC069
                  line-height 18px
                .update
                  display flex
                  float right
                  align-items center
                  
                  .time
                    font-size 12px
                    color #999999
                    display flex
                    align-items center
                    height 20px
                    .iconfont
                      line-height 20px
                      position relative
                      top 1px
                      right 2px
          .report-chart
            background #F9F9F9
            padding 20px 12px
            margin-top 20px
            .item-wrap
              .chart-item
                width 167px
                display inline-block
                &:not(:nth-child(4n))
                  margin-right 12px
                .chart
                  width 167px
                  height 125px
                  background #FFFFFF
                  display flex
                  justify-content center
                  align-items center
                  position relative
                  cursor pointer
                  img
                    max-width 146px
                    max-height 100px
                    transition all .5s
                  &:hover
                    img
                      transform scale(1.1)
                  .shoucang
                    display inline-flex
                    justify-content center
                    align-items center
                    border-radius 3px
                    margin-left 10px
                    width 21px
                    height 21px
                    background #F3F3F3
                    cursor pointer
                    position absolute
                    right 8px
                    top 8px
                    .iconfont
                      color #CCCCCC
                      font-size 14px
                    &.on
                      background #FA5A00
                      .iconfont
                        color #fff
                .chart-title
                  margin-top 10px
                  font-size 14px
                  
                  font-weight bold
                  color #333333
                  line-height 20px
                  cursor pointer
                  height 40px
                  transition all .5s
                  -webkit-transition all .5s
                  >>> .high-light
                    font-style normal
                    color #FA5A00
                  &:hover
                    color #FA5A00
            .desc
              margin-top 6px
              display flex
              justify-content space-between
              .number
                font-size 12px
                
                font-weight 400
                color #666666
                line-height 20px
              button
                height 24px
                background #F9F9F9
                border 0.5px solid #FA5A00
                font-size 12px
                
                font-weight 400
                color #FA5A00
                line-height 20px
                cursor pointer
                text-align center
                transition all .5s
                -webkit-transition all .5s
                &:hover
                  border 0.5px solid #FF4800
                  color #FF4800
              .folder
                width 50px
              .more-chart
                width 80px
          .chart-set
            background #F8F9FA
            border 1px solid #FA5A00
            .chart-item
              &:not(:nth-child(4n))
                margin-right 11px !important
            .more-char-set
              text-align center
              margin-top 10px
              button
                width 162px
                height 30px
                background #FA5A00
                border-radius 15px
                border none
                font-size 12px
                
                font-weight 400
                color #FFFFFF
                cursor pointer
                transition all .5s
                -webkit-transition all .5s
                &:hover
                  background #FF4800
                  
    .right-wrap
      width 342px
  >>>.ivu-spin
    margin-top 20px
    color #FA5A00
  .login-tip
    width: 100%;
    height: 36px;
    background: #fff7f0;
    margin-top: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    color #999999
    span
      cursor: pointer;
      color #FA5A00
      &:hover
        color #FF4800
</style>
